import GameState from "slotworks/model/game-state";
import RecoverMatrix from "slotworks/state-machine/standard/states/recover-matrix";
import { Services } from "slotworks/services/services";
import PickMatchRecord from "slotworks/model/gameplay/records/pick-match-record";
import gameState from "slotworks/model/game-state";

// Jump the reels to the root spin records grid
export default class CGRecoverMatrix extends RecoverMatrix {
    public onEnter() {

        const gameplay = gameState.getCurrentGame();
        Services.transaction.setWinnings(gameplay.getTotalWin()).execute();
        Services.transaction.setBalance(gameplay.balance);

        super.onEnter();
    }
}
